<h3>Welcome to Impata FAQ</h3>

<div class="">
    <div class="row">  
        <div class="display-4 col-12 m-3" style="border-left: solid rgb(122, 248, 168) 5px;" > Popular Topics : </div>
        <div class="col-md-4">
            <div class="card">       
                <div class="card-body">
        
                </div>
                <div class="card-footer text-center">
                    <h4 class="display-5">Create a School</h4>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card">       
                <div class="card-body">
        
                </div>
                <div class="card-footer text-center">
                    <h4 class="display-5">Create a Course</h4>
                </div>
            </div>
        </div>
        <div class="col-md-4">
            <div class="card">       
                <div class="card-body">
        
                </div>
                <div class="card-footer text-center">
                    <h4 class="display-5">Create a Lesson</h4>
                </div>
            </div>
        </div>
        
    </div>
</div>

<div class="row">  
    <div class="display-4 col-12 m-3" style="border-left: solid rgb(122, 248, 168) 5px;" > Topics : </div>
    

    
    <div class="m-3">
        <p> What is Impata? </p>
        <p> How many students can I have on Impata? </p>
        <p> Do I need to buy other software to use Impata? </p>
    </div>
</div>
